import React from "react";

import State from "../../../../containers/State";
import { ReactComponent as StateIcon } from "../../../../img/icons/SanJose.svg";
import { CAMPAIGN_2021 } from '../../../../constants';

const stateName = "San José";
const stateId = "f0amSpxOTAy4QVyq78ex";

const SanJose = () => {
  return (
    <State stateName={stateName} stateId={stateId} Icon={StateIcon} year="2021" campaign={CAMPAIGN_2021}>
      <StateIcon />
    </State>
  );
};

export default SanJose;
